// Training creation form
import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';

@Component({
  selector: 'app-create-training-form',
  templateUrl: './create-training-form.component.html',
  styleUrls: ['./create-training-form.component.scss']
})
export class CreateTrainingFormComponent {

  //training request id
  // @Input() request: string | any;

  //training data
  @Input() data: any;

  message: any = undefined

  createTrainingForm: FormGroup | any;
  createSessionForm: FormGroup | any;
  createProgramForm : FormBuilder | any
  sectionTypeIdHolder : any
  trainingTypes: any[] = [];
  city: Array<Location | any> = [];

  // file urls 
  apilink = GlobalConstants.apiURL;
  GlobalConstants = GlobalConstants;
  staticURL = GlobalConstants.staticFilesURL;
  trainingImage : string = ''

  // session types
  sessionTypes = [
    { value: 'COURSE', label: 'Course', icon: 'pi pi-map-marker' },
    // { value: 'PROGRAM', label: 'Program', icon: 'pi pi-map-marker' },
    { value: 'ASSESSMENT', label: 'Assessment', icon: 'pi pi-map-marker' },
    { value: 'SURVEY', label: 'الاستبيانات', icon: 'pi pi-map-marker' }
  ]

  courses : any = [];

  assessments : any = [];
  surveys : any = [];
  


  trainers = [
    { name: 'Mateen', code: 'AU' },
    { name: 'Zaid', code: 'BR' },
    { name: 'Rao', code: 'CN' },
    { name: 'Junaid', code: 'EG' },
    { name: 'Fatima', code: 'FR' },
    { name: 'Mahir', code: 'DE' },
    { name: 'Ali', code: 'IN' },
    { name: 'Sufiyan', code: 'JP' },
    { name: 'Osama', code: 'ES' },
    { name: 'Rehman', code: 'US' }
];




  // From step handlers
  steps: any =  [
    { title : 'التفاصيل العامة' , value : 1},
    { title : 'التفاصيل' , value : 2},
    { title : 'المعاينة' , value : 3},
    { title : 'موافق' , value : 4},
  ]

  step : any = { title : 'التفاصيل العامة' , value : 1}
  description: any;



  constructor(
    private formBuilder: FormBuilder,
    private dataService: DataService,
    // private cdr:ChangeDetectorRef
  ) { }

  ngOnInit() {
    console.log("==>Data", this.data)
    Promise.all([this.constructForObject(), this.getTrainingTypes(), this.getCity(),this.getSurveys(),this.getAssessments(),this.getCourse()])
  }

  //creating validation object for training
  constructForObject() {
    this.createTrainingForm = this.formBuilder.group({
      title: [null, [Validators.required, Validators.minLength(3)]],
      description:  [null, [Validators.required, Validators.minLength(3)]],
      timeline: [null, [Validators.required]],
    });

    this.createSessionForm = this.formBuilder.group({
      title: [null, [Validators.required, Validators.minLength(3)]],
      type: [null, [Validators.required]],
      date: [null, [Validators.required]],
      start_time: [null, [Validators.required]],
      end_time: [null, [Validators.required]]
    });

    this.createProgramForm = this.formBuilder.group({
      trainer: [null, [Validators.required, Validators.minLength(3)]],
      is_online: [null, []],
      houseNumber: [null, []],
      street: [null, []],
      city: [null, []],
    });

  }

  //get all cities
  async getCity() {
    try {
      let res = await this.dataService.getData('location');
      if (!res.error) {
        this.city = res.data.map((location: any) => {
          return {
            value: location.name,
            label: location.name,
            icon: 'pi pi-map-marker',
          };
        });
      }
    } catch (error) {
      console.log(error);
    }
  }


  // get training types
  private async getTrainingTypes(): Promise<void> {
    let res = await this.dataService.postData('training-type/get', {
      active: true,
    });
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.trainingTypes = res.data.map((item: any) => {
      return {
        _id: item._id,
        label: item.arabic,
        icon: `pi pi-${item.icon}`,
        value: item._id,
      };
    });
  }

   // get Surveys
   private async getSurveys(): Promise<void> {
    let res = await this.dataService.getData('survey');
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.surveys = res.data.map((item: any) => {
      return {
        _id: item._id,
        surveyTitle: item.name,
        surveyType: item.type.map((type : any)=> type.name).join(', '),
        description: item.comments,
      };
    });
  }

   // get assessments
   private async getAssessments(): Promise<void> {
    let res = await this.dataService.getData('assessment');
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.assessments = res.data.map((item: any) => {
      return {
        _id: item._id,
        assessmentTitle: item.name,
        assessmentType: item.type,
        description: item.description,
      };
    });
  }

   // get course
   private async getCourse(): Promise<void> {
    let res = await this.dataService.getData('course');
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.courses = res.data
  }

  //modals to open session types ID
  openCourseModal : boolean = false
  openAssessmentModal : boolean = false
  openSurveyModal : boolean = false
  openProgramModal : boolean = false

  //handle session type
  selectSessionTypeID($event : string){
    switch ($event) {
      case 'COURSE':
        this.openCourseModal = true
        break;
      case 'PROGRAM':
        this.openProgramModal = true
        break;
      case 'ASSESSMENT':
        this.openAssessmentModal = true
        break;
      case 'SURVEY':
        this.openSurveyModal = true
        break;  
      default:
    }

    //updating validators
    if ($event === 'COURSE') {
      this.createSessionForm.get('start_time').clearValidators();
      this.createSessionForm.get('end_time').clearValidators();
    } else {
      this.createSessionForm.get('start_time').setValidators([Validators.required]);
      this.createSessionForm.get('end_time').setValidators([Validators.required]);
    }

    this.createSessionForm.get('start_time').updateValueAndValidity();
    this.createSessionForm.get('end_time').updateValueAndValidity();


  }


  //set session holder
  setSessionTypeHolder(data : any){
    this.sectionTypeIdHolder = data
    console.log("==>session type data get = ", data, this.sectionTypeIdHolder)
  }


  // handle Session Submission
  onSubmitProgram(){
    console.log("tg==this.createProgramForm.value", this.createProgramForm.value);
    // let { trainer , is_online , houseNumber , street , city } = this.createProgramForm.value
    this.sectionTypeIdHolder = this.createProgramForm.value;
  
    this.openProgramModal = false

  }


  totalSessions : any  = []

  // handle Session Submission
  onSubmitSession(){

    //constructing session object
    let { title , type , date , start_time , end_time } = this.createSessionForm.value

    let data : any = {
      title : title,
      type : type,
      typeId : {...this.sectionTypeIdHolder},
      date : date.toUTCString(),
      start_time : start_time,
      end_time : end_time
    }
    this.totalSessions.push(data);
    this.resetSession()

  }

  resetSession(){
    this.sectionTypeIdHolder = null
    this.createProgramForm.reset()
    this.createSessionForm.reset()
  }

  // handle form submission  
  async onSubmit() {
    try {
      
      // let data: any = this.constructBasicCourseObject(this.createCourseForm.value);


      this.constructCompleteTrainingObject();

      let data = this.completeTrainingObject;

      console.log("Data To send ==>", data)

      let response = await this.dataService.postData('training/', data);
   
      if (response.error == true) {
        this.message = response.msg;
      } else {
        //updating request
        let req = {
          _id : this.data._id,
          status : 'TRAINING_CREATED',
          trainingId : response.data._id,
          createdType : 'TRAINING'
          //have to add trining id here
        }
        let res = await this.dataService.postData('training-req/',req,'PUT',false);
        this.step = this.steps[this.step.value] ;
        this.message = response.msg;
      }
    } catch (error) {
      console.log(error)
    }

  }

  constructTrainingObject(form: any) {
    return {
      title: form.title,
      type: this.data,
      image: this.trainingImage,
      description : form.description,
      start_date: form.timeline[0].toUTCString(),
      end_date: form.timeline[1].toUTCString()
    }
  }


  completeTrainingObject : any 
//   = {
//     "title": "New training Created",
//     "type": {
//         "_id": "64ddcf4a204862bd45db833f",
//         "topic": "Mini Training",
//         "type": {
//             "_id": "64dd16d9560e4f69ed29319e",
//             "name": "new type",
//             "arabic": "Test Type",
//             "icon": "pi pi-android",
//             "active": true,
//             "createdAt": "2023-08-16T18:35:05.972Z",
//             "updatedAt": "2023-08-16T18:35:05.972Z",
//             "__v": 0
//         },
//         "status": "PENDING",
//         "active": true,
//         "description": "Do the mini training of one day",
//         "createdAt": "2023-08-17T07:42:02.007Z",
//         "updatedAt": "2023-08-17T07:42:02.007Z",
//         "__v": 0
//     },
//     "address": {
//         "houseNo": "67",
//         "street": "Alfalah",
//         "city": " 1 Makah"
//     },
//     "start_date": "Fri, 18 Aug 2023 19:00:00 GMT",
//     "end_date": "Wed, 23 Aug 2023 19:00:00 GMT",
//     "session": [
//         {
//             "title": "Sir Atrif Program",
//             "type": "PROGRAM",
//             "typeId": {
//                 "trainer": {
//                     "name": "Zaid",
//                     "code": "BR"
//                 },
//                 "is_online": true,
//                 "houseNumber": null,
//                 "street": null,
//                 "city": null
//             },
//             "date": "Wed, 16 Aug 2023 19:00:00 GMT",
//             "start_time": "12:37",
//             "end_time": "22:40"
//         },
//         {
//             "title": "Quiz",
//             "type": "ASSESSMENT",
//             "typeId": {
//                 "_id": "1",
//                 "assessmentTitle": "Leadership Skills Quiz",
//                 "assessmentType": "Multiple Choice",
//                 "description": "Evaluate your understanding of leadership principles and team management strategies with this quiz."
//             },
//             "date": "Tue, 22 Aug 2023 19:00:00 GMT",
//             "start_time": "12:41",
//             "end_time": "12:41"
//         },
//         {
//             "title": "Finding Session",
//             "type": "SURVEY",
//             "typeId": {
//                 "_id": "2",
//                 "surveyTitle": "Training Needs Assessment",
//                 "surveyType": "Multiple Choice",
//                 "description": "Identify your training needs by selecting areas you feel require further development."
//             },
//             "date": "Sun, 27 Aug 2023 19:00:00 GMT",
//             "start_time": "22:40",
//             "end_time": "13:38"
//         }
//     ]
// }

  //creating complete training object with sessions
  constructCompleteTrainingObject(){

    console.log("=== test 1 ");

    if( this.step.value == 1 && this.createTrainingForm.value.timeline[1] == null){
      return
    }

    console.log("=== test 2 ");

    //changing Step
    this.step = this.steps[this.step.value]; 

    console.log("=== test 3 ");

    if(this.step.value < 3) return

    console.log("=== test 4");

    this.completeTrainingObject = this.constructTrainingObject(this.createTrainingForm.value);
    this.completeTrainingObject.session = this.totalSessions

    console.log("=== test 5 ");
  }

  reload(){
    window.location.reload()
  }


}
